import React from 'react';
import { View } from 'react-native';
import { compose } from 'redux';

import { CreatorContainer } from '../../containers';

import { Text, TextInput } from '../../components';
import { PrimaryButton } from '../../design/components';
import { useUserContext } from '../../../common/utils/context';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import SwitchWithLabel from '../../components/switch/SwitchWithLabel';
import { createNoteFormStyles } from './noteFormStyles';

const NoteCreator = ({
	values,
	onChange,
	changeFormValue,
	onSubmit,
	showImportant,
}) => {
	const { user } = useUserContext();
	const styles = useThemedStyles(createNoteFormStyles);

	return (
		<View style={styles.form}>
			<View style={styles.field}>
				<Text style={styles.label}>Description</Text>
				<TextInput
					multiline={true}
					numberOfLines={4}
					style={styles.multilineInput}
					value={values.description}
					onChange={onChange('description')}
				/>
			</View>
			{
				user.role?.canSeeAdminNotes && (
					<SwitchWithLabel
						value={values.isAdminNote}
						label="Admin note"
						onValueChange={() => changeFormValue({ isAdminNote: !values.isAdminNote })}
					/>
				)
			}
			{
				Boolean(showImportant) && (
					<SwitchWithLabel
						onValueChange={() => changeFormValue({ isImportant: !values.isImportant })}
						value={values.isImportant}
						label="Important"
					/>
				)
			}
			<PrimaryButton
				label="Create note"
				disabled={!values.description}
				onPress={onSubmit}
			/>
		</View>
	);
};

export default compose(CreatorContainer)(NoteCreator);
